import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { MaestroProvider } from './context/MaestroContext';
import maestroService from './maestroService';
import MaestroSidebarMenu from './MaestroSidebarMenu';
import MaestroApuracaoTributariaPage from './pages/MaestroApuracaoTributariaPage';
import MaestroCockpitPage from './pages/MaestroCockpitPage';
import MaestroLogsPage from './pages/MaestroLogsPage';
import MaestroNotificacoesPage from './pages/MaestroNotificacoesPage';
import MaestroRelatorioPage from './pages/MaestroRelatorioPage';
import MaestroSetupPage from './pages/MaestroSetupPage';
import './maestro-contabil.scss';

const Spinner: React.FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: 12, color: '#a1a5b7' }}>
    <div style={{ width: 28, height: 28, border: '3px solid #e8f4fb', borderTopColor: '#005e96', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    <span>Verificando configuração...</span>
  </div>
);

const MaestroRoutes: React.FC = () => {
  const { path } = useRouteMatch();
  const location = useLocation();

  // Trava de setup (mesmo padrão do Workflow SOX/WorkflowRoutes.tsx): enquanto o setup do módulo
  // (MAESTRO-RN-18) não estiver ATIVO, o Cockpit raiz redireciona para /setup em vez de mostrar um
  // cockpit vazio — as demais sub-rotas (setup, logs, fiscal, relatório) continuam navegáveis
  // diretamente, o wizard de setup pode precisar ser acessado de qualquer ponto.
  const [carregandoSetup, setCarregandoSetup] = useState(true);
  const [setupAtivo, setSetupAtivo] = useState(true);

  useEffect(() => {
    let cancelado = false;
    maestroService.obterSetup()
      .then(({ status }) => { if (!cancelado) setSetupAtivo(status === 'ATIVO'); })
      .catch(() => { if (!cancelado) setSetupAtivo(true); })
      .finally(() => { if (!cancelado) setCarregandoSetup(false); });
    return () => { cancelado = true; };
  }, []);

  if (carregandoSetup) return <Spinner />;

  const isRootCockpit = location.pathname === path || location.pathname === `${path}/`;
  if (!setupAtivo && isRootCockpit) {
    return <Redirect to={`${path}/setup`} />;
  }

  return (
    <MaestroProvider>
      <div className='mc-modulo'>
        <MaestroSidebarMenu />
        <Switch>
          <Route exact path={path} component={MaestroCockpitPage} />
          <Route exact path={`${path}/setup`} component={MaestroSetupPage} />
          <Route exact path={`${path}/logs`} component={MaestroLogsPage} />
          <Route exact path={`${path}/notificacoes`} component={MaestroNotificacoesPage} />
          <Route exact path={`${path}/fiscal`} component={MaestroApuracaoTributariaPage} />
          <Route exact path={`${path}/relatorio`} component={MaestroRelatorioPage} />
          <Redirect to={path} />
        </Switch>
      </div>
    </MaestroProvider>
  );
};

export default MaestroRoutes;
